module.exports = __webpack_public_path__ + "static/media/back.acfa738d.svg";